module.exports = __webpack_public_path__ + "img/photo-0091.ec44a243.jpg";